import { USER_ROLE } from 'utils/enums/user-role.enum';
import Cookies from 'js-cookie';

export function handleRedirectRoute(): string {
	const role = Cookies.get('role');

	if (role === USER_ROLE.WRITER || role === USER_ROLE.SOURCER) return '/writer/my-stories';

	if (role === USER_ROLE.ADMIN) return '/admin/content';

	if (role === USER_ROLE.MODERATOR) return '/admin/requests';

	return '/auth/log-in';
}
